
riot.tag2('section-list-items', '  <catalog name="section-item" sortable="true" object="SectionItem" cols="{cols}" combine-filters="true" disable-limit="true" handlers="{itemsHandlers}" disable-col-select="true" store="section-list-items" add="{add}" remove="{remove}" dblclick="{objectOpen}" filters="{opts.filters}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="enabled">\n        <button class="btn btn-default btn-sm" type="button" onclick="{handlers.boolChange}" ontouchend="{handlers.boolChange}" ontouchstart="{stopPropagation}"><i class="fa {row.enabled ? &quot;fa-eye text-active&quot; : &quot;fa-eye-slash text-noactive&quot;} "></i></button>\n      </datatable-cell>\n      <datatable-cell name="imageUrlPreview"><img riot-src="{row.imageUrlPreview}" alt="" width="60"></datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="type">{handlers.types[row.type]}</datatable-cell>\n      <datatable-cell name="note">{row.note}</datatable-cell>\n      <datatable-cell name="sort" style="width: 10px;">{row.sort}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.collection = 'SectionItem';
self.idSection = 0;

self.mixin('remove');

var route = riot.route.create();

self.cols = [{ name: 'id', value: '#' }, { name: 'enabled', value: 'Вид' }, { name: 'imageUrlPreview', value: '' }, { name: 'name', value: 'Наименование' }, { name: 'type', value: 'Тип элемента' }, { name: 'note', value: 'Примечание' }, { name: 'sort', value: 'Поряок' }];

self.itemsHandlers = {
    types: {
        idPrice: 'Товар',
        idGroup: 'Категория товара',
        idBrand: 'Бренд',
        idNew: 'Новость',
        url: 'Ссылка'
    },
    boolChange: function boolChange(e) {
        var _this = this;
        e.stopPropagation();
        e.stopImmediatePropagation();
        _this.row[_this.opts.name] = _this.row[_this.opts.name] ? 0 : 1;
        self.update();

        var params = {};
        params.id = _this.row.id;
        params[_this.opts.name] = _this.row[_this.opts.name];
        API.request({
            object: 'SectionItem',
            method: 'Save',
            data: params,
            error: function error(response) {
                rows.forEach(function (item) {
                    item[field] = oldValues[item.id][field];
                });
                self.update();
            }
        });
    }
};

observable.on('section-reload', function () {
    self.tags['section-item'].reload();
});

self.add = function (e) {
    if (opts.section) riot.route('/sections/new?section=' + opts.section);else popups.create({ title: 'Внимание!', text: 'Для добавления записи необходимо выбрать раздел!', style: 'popup-warning' });
};

self.objectOpen = function (e) {
    return riot.route('/sections/' + e.item.row.id);
};

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/sections/section-list-items.tag